export const liveTableConfig = {
  propList: [
    {prop: 'empName', label: '业务员', minWidth: '60', slotName: 'consumer'},
    {prop: 'statisticsCount', label: '观看客户数', minWidth: '60', sortable: true}
  ]
}
